<template lang="pug">
  .slide-layout
    .cus-box
      .slide-title 海报预览
      .poster
        img.p-background(:src="poster_info.poster_img")
        .store
          .left
            .store-name.character-hiding-o {{ poster_info.store_name}}
            .store-address.character-hiding-o {{poster_info.address}}
            .store-phone {{poster_info.store_phone}}
          .right
            img(:src="poster_info.qr_code ? poster_info.qr_code : 'https://chedian-oss1.vchangyi.com/images/staticmnbxhs.png'", :class="poster_info.qr_code ? '' : 'blur'")
</template>
<script>
import FilterTools from '@/mixins/utilities/filterTools'
export default {
  name: 'ViewPoster',
  mixins: [FilterTools],
  props: {
    poster_info: {
      type: Object,
    },
  },
  data () {
    return {}
  },
  methods: {},
  mounted () {
    console.log(this.poster_info)
  },
}
</script>

<style lang="stylus" scoped>
.slide-layout
  // width 375px
  padding 0
  .slide-title
    padding-left 40px
  .poster
    width 315px
    height 100%
    margin 0 auto
    border-radius: 10px
    overflow: hidden
    background-color #DEDEDE
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    .p-background
      width 100%
      height 430px
      // padding 0 25px 20px
      display:block;
      position relative
    .store
      width 100%
      height 110px
      background-color #ffffff
      padding 20px
      display flex
      justify-content space-between
      .left
        width 200px;
        .store-name
          font-size: 16px;
          font-weight: 500;
          color: #404040;
          margin-bottom 2px
          line-height 22px
        .store-address,.store-phone
          font-size 12px
          color: #6E6E72;
          text-indent 14px
          margin-top 6px
          line-height 17px
          position relative
        .store-address::after
          position absolute
          top 3px
          left 0
          content: ''
          width 9px
          height 12px
          background: url('~@/assets/icons/address-icon.png') no-repeat
          background-size contain
        .store-phone::after
          position absolute
          top 3px
          left 0
          content: ''
          width 9px
          height 12px
          background: url('~@/assets/icons/phone-icon.png') no-repeat
          background-size contain
      .right
        width 72px
        height 72px
        background-color #eeeeee
        margin-right 10px
        img
          width 72px
          height 72px
        img.blur
          filter blur(3px)
      
</style>



// WEBPACK FOOTER //
// src/components/content/modal/ViewPoster.vue